import { render, staticRenderFns } from "./CertificationSettings.vue?vue&type=template&id=9fcf45e2&"
import script from "./CertificationSettings.vue?vue&type=script&lang=js&"
export * from "./CertificationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports